"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.checkIsBrowser = checkIsBrowser;
exports.checkIsAliMiniAPP = checkIsAliMiniAPP;
exports.checkIsAlipayMiniAPP = checkIsAlipayMiniAPP;
exports.checkIsSupportWS = checkIsSupportWS;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SESSION_STORAGE_DATA = void 0;
var sysInfo = {};
try {
  if (checkIsAliMiniAPP()) {
    sysInfo = my.getSystemInfoSync && my.getSystemInfoSync() || {};
  }
} catch (e) {
  sysInfo = {};
}

// 只有状态为ONOPEN时候，才可以发送消息
var SOCKET_STATUS = {
  INITITIALIZED: 0, // 初始化
  ONOPEN: 1, // 连接成功回调，说明socket可以使用
  CLOSE: 2, // 主动关闭
  ONCLOSE: 3, // socket已关闭
  CONNECTFAILED: 4, // 连接失败
  ONSOCKETERROR: 5 // socket出现异常
};

function getWebSocket() {
  var UnifyWebSocket = void 0;

  if (checkIsBrowser() && window.WebSocket) {
    // 浏览器环境
    UnifyWebSocket = window.WebSocket;
  }

  if (checkIsAliMiniAPP() && my.connectSocket) {
    // 集团小程序环境
    UnifyWebSocket = function () {
      function UnifyWebSocket(url) {
        var _this = this;

        _classCallCheck(this, UnifyWebSocket);

        my.connectSocket({
          url: url,
          success: function success() {
            // Do nothing
          },

          fail: function fail(res) {
            _this.readyState = SOCKET_STATUS.CONNECTFAILED;
            _this && _this._onError && typeof _this._onError === "function" && _this._onError(res);
          }
        });
        this.readyState = SOCKET_STATUS.INITITIALIZED;

        my.onSocketOpen(function (res) {
          if (!_this) {
            return;
          }
          _this.readyState = SOCKET_STATUS.ONOPEN;
          _this.onopen && typeof _this.onopen === "function" && _this.onopen(res);
        });

        my.onSocketClose(function (res) {
          if (!_this) {
            return;
          }
          _this.readyState = SOCKET_STATUS.ONCLOSE;
          _this.onclose && typeof _this.onclose === "function" && _this.onclose(res);
        });

        my.onSocketError(function (res) {
          if (!_this) {
            return;
          }
          _this.readyState = SOCKET_STATUS.ONSOCKETERROR;
          _this._onError && typeof _this._onError === "function" && _this._onError(res);
        });

        my.onSocketMessage(function (res) {
          if (!_this) {
            return;
          }
          _this.onmessage && typeof _this.onmessage === "function" && _this.onmessage(res);
        });
      }

      _createClass(UnifyWebSocket, [{
        key: "_onError",
        value: function _onError(res) {
          if (!this) {
            return;
          }
          this.onerror && typeof this.onerror === "function" && this.onerror(res);
        }
      }, {
        key: "close",
        value: function close() {
          this.readyState = SOCKET_STATUS.CLOSE;
          my.closeSocket();
        }
      }, {
        key: "send",
        value: function send(data) {
          // 添加保护，android如果socket通道关闭或者出现error或者建立连接失败，如果再发消息，就会失败
          // 等网络回复 或者从后台唤起appx还会open该长连接，所以只有当收到onSocketOpen回调才能够发消息
          if (this.readyState !== SOCKET_STATUS.ONOPEN) {
            return;
          }
          my.sendSocketMessage({
            data: data,
            fail: function fail(res) {
              throw res;
            }
          });
        }
      }]);

      return UnifyWebSocket;
    }();
  }

  if (!UnifyWebSocket) {
    throw 'Not find WebSocket API!';
  }

  return UnifyWebSocket;
}

function getSessionStorage() {
  if (checkIsBrowser()) {
    return window.sessionStorage;
  } else {
    SESSION_STORAGE_DATA = SESSION_STORAGE_DATA || {};
    return {
      setItem: function setItem(key, value) {
        SESSION_STORAGE_DATA[key] = value;
      },
      getItem: function getItem(key) {
        return SESSION_STORAGE_DATA[key];
      }
    };
  }
}

function checkIsBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined' && !checkIsAliMiniAPP(); // 只判断window和document的话小程序的ide预览、debug模式都会误判
}

function checkIsAliMiniAPP() {
  return typeof my !== 'undefined';
}

function checkIsAlipayMiniAPP() {
  return sysInfo && sysInfo.app && sysInfo.app === 'alipay';
}

function checkIsSupportWS() {
  return checkIsBrowser() && window.WebSocket || checkIsAliMiniAPP() && my.connectSocket;
}

var WebSocket = exports.WebSocket = getWebSocket();
var sessionStorage = exports.sessionStorage = getSessionStorage();